/* ============================================================
   SUSHENAH Quiz Page JavaScript
   Bible 4.2: Find Your Cause Quiz Logic
   ============================================================ */

(function() {
  'use strict';

  // Cause data with sublines and page links
  const CAUSES = {
    dehydration: {
      name: 'Dehydration & Barrier',
      subline: '"When your skin can\'t hold onto moisture"',
      pageUrl: '/pages/cause-dehydration',
      products: {
        primary: {
          handle: 'hydration-care-butter',
          name: 'Hydration Care Butter',
          price: '₹945',
          image: null
        },
        secondary: {
          handle: 'hydration-care-serum',
          name: 'Hydration Care Serum',
          price: '₹545',
          image: null
        }
      }
    },
    pigmentation: {
      name: 'Pigmentation',
      subline: '"When melanin overproduces in patches"',
      pageUrl: '/pages/cause-pigmentation',
      products: {
        primary: {
          handle: 'pigment-care-butter',
          name: 'Pigment Care Butter',
          price: '₹945',
          image: null
        },
        secondary: {
          handle: 'pigment-care-serum',
          name: 'Pigment Care Serum',
          price: '₹545',
          image: null
        }
      }
    },
    collagen: {
      name: 'Collagen & Elasticity',
      subline: '"When support structure rebuilds slower than it breaks down"',
      pageUrl: '/pages/cause-collagen',
      products: {
        primary: {
          handle: 'stretch-marks-care-butter',
          name: 'Stretch Marks Care Butter',
          price: '₹1,090',
          image: null
        },
        secondary: {
          handle: 'collagen-care-serum',
          name: 'Collagen Care Serum',
          price: '₹695',
          image: null
        }
      }
    },
    inflammation: {
      name: 'Inflammation',
      subline: '"When your skin\'s alarm won\'t turn off"',
      pageUrl: '/pages/cause-inflammation',
      products: {
        primary: {
          handle: 'inflammation-care-butter',
          name: 'Inflammation Care Butter',
          price: '₹895',
          image: null
        },
        secondary: {
          handle: 'inflammation-care-serum',
          name: 'Inflammation Care Serum',
          price: '₹545',
          image: null
        }
      }
    }
  };

  // Pregnancy-specific products
  const PREGNANCY_PRODUCTS = {
    primary: {
      handle: 'stretch-marks-care-butter',
      name: 'Stretch Marks Care Butter',
      price: '₹1,090',
      image: null
    },
    secondary: {
      handle: 'nipple-care-butter',
      name: 'Nipple Care Butter',
      price: '₹495',
      image: null
    }
  };

  // Quiz state
  let currentQuestion = 1;
  let answers = {};
  let quizSection = null;

  // LocalStorage key for persistence
  const STORAGE_KEY = 'sushenah_quiz_results';
  const STORAGE_EXPIRY_DAYS = 30;

  // Initialize quiz
  function init() {
    quizSection = document.querySelector('.quiz-page');
    if (!quizSection) return;

    // Check for saved results
    const savedResults = getSavedResults();
    if (savedResults) {
      showSavedResultsBanner(savedResults);
    }

    bindEvents();
    console.log('SUSHENAH Quiz initialized');
  }

  // Get saved results from localStorage
  function getSavedResults() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return null;

      const data = JSON.parse(stored);

      // Check if expired
      const expiryDate = new Date(data.expiresAt);
      if (expiryDate < new Date()) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return data;
    } catch (e) {
      console.warn('Could not read saved quiz results:', e);
      return null;
    }
  }

  // Save results to localStorage
  function saveResults(cause, answers) {
    try {
      const expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + STORAGE_EXPIRY_DAYS);

      const data = {
        cause: cause,
        answers: answers,
        completedAt: new Date().toISOString(),
        expiresAt: expiryDate.toISOString()
      };

      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      return true;
    } catch (e) {
      console.warn('Could not save quiz results:', e);
      return false;
    }
  }

  // Clear saved results
  function clearSavedResults() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      console.warn('Could not clear saved results:', e);
    }
  }

  // Show banner for returning visitors with saved results
  function showSavedResultsBanner(savedData) {
    const causeData = CAUSES[savedData.cause];
    if (!causeData) return;

    const completedDate = new Date(savedData.completedAt);
    const daysAgo = Math.floor((new Date() - completedDate) / (1000 * 60 * 60 * 24));
    const timeText = daysAgo === 0 ? 'today' : daysAgo === 1 ? 'yesterday' : `${daysAgo} days ago`;

    // Create banner element
    const banner = document.createElement('div');
    banner.className = 'quiz-page__saved-banner';
    banner.innerHTML = `
      <div class="quiz-page__saved-banner-content">
        <div class="quiz-page__saved-banner-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <polyline points="22 4 12 14.01 9 11.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="quiz-page__saved-banner-text">
          <p><strong>Welcome back!</strong> You completed this quiz ${timeText}.</p>
          <p>Your result: <a href="${causeData.pageUrl}">${causeData.name}</a></p>
        </div>
        <div class="quiz-page__saved-banner-actions">
          <button type="button" class="quiz-page__saved-banner-view" data-view-saved>View My Results</button>
          <button type="button" class="quiz-page__saved-banner-retake" data-retake-saved>Retake Quiz</button>
        </div>
      </div>
    `;

    // Insert banner before intro state
    const introState = quizSection.querySelector('[data-quiz-state="intro"]');
    if (introState) {
      introState.parentNode.insertBefore(banner, introState);
    }

    // Bind banner events
    const viewBtn = banner.querySelector('[data-view-saved]');
    const retakeBtn = banner.querySelector('[data-retake-saved]');

    if (viewBtn) {
      viewBtn.addEventListener('click', () => {
        answers = savedData.answers;
        showResults();
      });
    }

    if (retakeBtn) {
      retakeBtn.addEventListener('click', () => {
        banner.remove();
        clearSavedResults();
        startQuiz();
      });
    }
  }

  // Bind all event listeners
  function bindEvents() {
    // Start button
    const startBtn = quizSection.querySelector('[data-quiz-start]');
    if (startBtn) {
      startBtn.addEventListener('click', startQuiz);
    }

    // Option buttons
    const options = quizSection.querySelectorAll('.quiz-page__option');
    options.forEach(option => {
      option.addEventListener('click', handleOptionClick);
    });

    // Back button
    const backBtn = quizSection.querySelector('[data-quiz-back]');
    if (backBtn) {
      backBtn.addEventListener('click', goBack);
    }

    // Retake button
    const retakeBtn = quizSection.querySelector('[data-quiz-retake]');
    if (retakeBtn) {
      retakeBtn.addEventListener('click', retakeQuiz);
    }
  }

  // Start the quiz
  function startQuiz() {
    showState('questions');
    updateProgress();
  }

  // Handle option click
  function handleOptionClick(e) {
    const option = e.currentTarget;
    const questionNum = parseInt(option.dataset.questionNum);
    const answer = option.dataset.answer;

    // Store answer
    answers[questionNum] = answer;

    // Visual feedback - mark selected
    const siblings = option.parentElement.querySelectorAll('.quiz-page__option');
    siblings.forEach(sib => sib.classList.remove('selected'));
    option.classList.add('selected');

    // Brief delay then advance
    setTimeout(() => {
      if (questionNum < 5) {
        showQuestion(questionNum + 1);
      } else {
        showResults();
      }
    }, 300);
  }

  // Show specific question
  function showQuestion(num) {
    currentQuestion = num;

    // Hide all questions
    const questions = quizSection.querySelectorAll('.quiz-page__question');
    questions.forEach(q => q.style.display = 'none');

    // Show target question
    const targetQuestion = quizSection.querySelector(`[data-question="${num}"]`);
    if (targetQuestion) {
      targetQuestion.style.display = 'block';
      // Re-trigger animation
      targetQuestion.style.animation = 'none';
      targetQuestion.offsetHeight; // Trigger reflow
      targetQuestion.style.animation = '';
    }

    // Update progress
    updateProgress();

    // Show/hide back button
    const backBtn = quizSection.querySelector('[data-quiz-back]');
    if (backBtn) {
      backBtn.style.display = num > 1 ? 'inline-flex' : 'none';
    }
  }

  // Update progress dots
  function updateProgress() {
    const dots = quizSection.querySelectorAll('.quiz-page__dot');
    dots.forEach((dot, index) => {
      const dotNum = index + 1;
      dot.classList.remove('active', 'completed');

      if (dotNum < currentQuestion) {
        dot.classList.add('completed');
      } else if (dotNum === currentQuestion) {
        dot.classList.add('active');
      }
    });

    // Update text
    const progressText = quizSection.querySelector('[data-current-question]');
    if (progressText) {
      progressText.textContent = currentQuestion;
    }
  }

  // Go back to previous question
  function goBack() {
    if (currentQuestion > 1) {
      showQuestion(currentQuestion - 1);
    }
  }

  // Calculate and show results
  function showResults() {
    const cause = determineCause();
    const causeData = CAUSES[cause];
    const isPregnant = answers[3] === 'pregnancy';

    // Save results to localStorage for returning visitors
    saveResults(cause, answers);

    // Determine products
    let products;
    if (isPregnant) {
      products = PREGNANCY_PRODUCTS;
    } else {
      products = causeData.products;
    }

    // Update results card
    const causeEl = quizSection.querySelector('[data-results-cause]');
    const sublineEl = quizSection.querySelector('[data-results-subline]');
    const reasoningEl = quizSection.querySelector('[data-results-reasoning]');
    const causeLinkEl = quizSection.querySelector('[data-results-cause-link]');

    if (causeEl) causeEl.textContent = causeData.name;
    if (sublineEl) sublineEl.textContent = causeData.subline;
    if (causeLinkEl) causeLinkEl.href = causeData.pageUrl;

    // Build reasoning list
    if (reasoningEl) {
      const reasons = buildReasoning();
      reasoningEl.innerHTML = reasons.map(r => `<li>${r}</li>`).join('');
    }

    // Render products
    renderProducts(products);

    // Show results state
    showState('results');
  }

  // Determine primary cause based on answers
  function determineCause() {
    // Primary cause is determined by Q1
    const mainConcern = answers[1];

    // Q3 pregnancy can override to collagen
    if (answers[3] === 'pregnancy' && (mainConcern === 'collagen' || mainConcern === 'dehydration')) {
      return 'collagen';
    }

    return mainConcern || 'dehydration';
  }

  // Build reasoning text based on answers
  function buildReasoning() {
    const reasons = [];

    // Q1 - Main concern
    const concernTexts = {
      dehydration: 'Your main concern is dryness and tightness',
      pigmentation: 'Your main concern is dark patches or uneven tone',
      collagen: 'Your main concern is fine lines or stretch marks',
      inflammation: 'Your main concern is redness or sensitivity'
    };
    if (answers[1] && concernTexts[answers[1]]) {
      reasons.push(concernTexts[answers[1]]);
    }

    // Q2 - Duration
    const durationTexts = {
      recent: 'This started recently',
      months: 'This has been building for a few months',
      ongoing: 'This has been an ongoing struggle'
    };
    if (answers[2] && durationTexts[answers[2]]) {
      reasons.push(durationTexts[answers[2]]);
    }

    // Q3 - Life changes
    const lifeTexts = {
      pregnancy: "You're pregnant or recently gave birth",
      climate: "You've moved to a new climate",
      stress: "You've been more stressed than usual"
    };
    if (answers[3] && lifeTexts[answers[3]]) {
      reasons.push(lifeTexts[answers[3]]);
    }

    return reasons;
  }

  // Render product cards with images from Shopify
  // Uses Liquid-injected data (window.SUSHENAH_QUIZ_PRODUCTS) for instant prices
  async function renderProducts(products) {
    const container = quizSection.querySelector('[data-results-products]');
    if (!container) return;

    // Check for Liquid-injected product data (preferred - instant, no AJAX)
    const injectedData = window.SUSHENAH_QUIZ_PRODUCTS || {};

    // Use injected data if available, otherwise fetch via AJAX
    const primaryInjected = injectedData[products.primary.handle];
    const secondaryInjected = injectedData[products.secondary.handle];

    // If we have injected data, use it immediately (no loading state needed)
    if (primaryInjected && secondaryInjected) {
      products.primary.image = primaryInjected.image;
      products.primary.price = primaryInjected.price;
      products.secondary.image = secondaryInjected.image;
      products.secondary.price = secondaryInjected.price;
    } else {
      // Fallback: fetch via AJAX if Liquid injection failed
      container.innerHTML = '<div class="quiz-page__loading">Loading recommendations...</div>';

      const [primaryData, secondaryData] = await Promise.all([
        fetchProductData(products.primary.handle),
        fetchProductData(products.secondary.handle)
      ]);

      if (primaryData) {
        products.primary.image = primaryData.featured_image;
        products.primary.price = formatPrice(primaryData.price);
      }
      if (secondaryData) {
        products.secondary.image = secondaryData.featured_image;
        products.secondary.price = formatPrice(secondaryData.price);
      }
    }

    const primaryHtml = createProductCard(products.primary, 'primary');
    const secondaryHtml = createProductCard(products.secondary, 'secondary');

    container.innerHTML = primaryHtml + secondaryHtml;
  }

  // Fetch product data from Shopify AJAX API
  async function fetchProductData(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (response.ok) {
        return await response.json();
      }
    } catch (error) {
      console.warn(`Could not fetch product: ${handle}`, error);
    }
    return null;
  }

  // Format price from cents to rupees
  function formatPrice(priceInPaise) {
    const rupees = priceInPaise / 100;
    return '₹' + rupees.toLocaleString('en-IN');
  }

  // Create product card HTML
  function createProductCard(product, type) {
    const badgeClass = type === 'primary' ? 'quiz-page__product-badge--primary' : 'quiz-page__product-badge--secondary';
    const badgeText = type === 'primary' ? 'PRIMARY PICK' : 'ALSO HELPFUL';
    const productUrl = `/products/${product.handle}`;

    // Use actual image or fallback to placeholder
    const imageHtml = product.image
      ? `<img src="${product.image}" alt="${product.name}" loading="lazy">`
      : `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="opacity: 0.3;">
          <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.5"/>
          <circle cx="8.5" cy="8.5" r="1.5" stroke="currentColor" stroke-width="1.5"/>
          <path d="M21 15L16 10L5 21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;

    return `
      <div class="quiz-page__product">
        <span class="quiz-page__product-badge ${badgeClass}">${badgeText}</span>
        <div class="quiz-page__product-image">
          ${imageHtml}
        </div>
        <h4 class="quiz-page__product-name">${product.name}</h4>
        <p class="quiz-page__product-price">${product.price}</p>
        <a href="${productUrl}" class="quiz-page__product-btn">View Product</a>
      </div>
    `;
  }

  // Show specific state
  function showState(stateName) {
    const states = quizSection.querySelectorAll('.quiz-page__state');
    states.forEach(state => {
      const stateType = state.dataset.quizState;
      state.style.display = stateType === stateName ? 'block' : 'none';
    });
  }

  // Retake quiz
  function retakeQuiz() {
    // Reset state
    currentQuestion = 1;
    answers = {};

    // Clear selections
    const options = quizSection.querySelectorAll('.quiz-page__option');
    options.forEach(opt => opt.classList.remove('selected'));

    // Show first question
    showQuestion(1);

    // Show questions state
    showState('questions');
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
